<template>
  <div class="base-box">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <!-- 附件上传 -->
     <!-- <van-cell title="附件上传" required is-link @click="goUpload" value="请上传附件"/> -->
<p>标注 <span style="color:red">“ * ”</span> 的填写项为必填项,如空缺则不能完成注册</P>
    <h3>
      <van-icon name="column" />入会信息
    </h3>
      <div class="base-item">
          <van-cell
                  class="input-item"
                  title="单位类型"
                  :value="getName('GROUP_TYPE','memberType')"
                  is-link
                  @click="setSelectModel('GROUP_TYPE','name','memberType')"
          />
      </div>
    <div class="base-item">
      <van-cell
        class="input-item"
        title="选择单位"
        :value="getName('branchsList','recommendUnitId','选择单位')"
        is-link
        required
        @click="setSelectModel('branchsList','name','recommendUnitId')"
      />
    </div>
     <div class="base-item">
      <van-cell
        class="input-item"
        title="关注单位(如需关注多个单位,请在pc端选择)"
        :value="getName('branchsList','concernUnitId','关注单位')"
        is-link
        @click="setSelectModel('branchsList','name','concernUnitId')"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="历史会员号"
        input-align="right"
        v-model="params.historyMemberNo"
        clearable
        placeholder="请输入历史会员号"
      />
    </div>
    <h3> <van-icon name="column" />附件上传</h3>
    <!-- 附件上传 -->
   <div v-if="portraitName" style="font-size: 13px;line-height: 20px">{{"单位logo："+portraitName}}</div>
   <div v-if="licenceFileName" style="font-size: 13px;;line-height: 20px">{{"加盖公章的营业执照复印件："+licenceFileName}}</div>
    <van-cell title="附件上传" required is-link @click="goUpload" value="请上传附件"/>
    <!-- 基本信息 -->
    <h3>
      <van-icon name="column" />基本信息
    </h3>
    <div class="base-item">
      <p>单位会员名称<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.name"
        clearable
        placeholder="请输入单位名称"
      />
    </div>
    <div class="base-item">
      <p>统一社会信用代码<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.code"
        clearable
        placeholder="请输入统一社会信用代码"
      />
    </div>
    <div class="base-item">
        <van-cell
                class="input-item"
                title="成立日期"
                :value="foundDate"
                is-link
                required
                @click="setSelectModel('foundDate','foundDate','foundDate')"
        />
    </div>
    <div class="base-item">
      <p>住所<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.registrationFullAddress"
        clearable
        placeholder="请输入住所"
      />
    </div>
    <div class="base-item">
      <p>注册资本金（万元）<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.registeredCapital"
        clearable
        placeholder="请输入注册资本金"
      />
    </div>
    <div class="base-item">
      <p>职工人数<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.researcherCount"
        clearable
        placeholder="请输入职工人数"
      />
    </div>
    <div class="base-item">
      <p>网址</p>
      <van-field
        class="input-item"
        v-model="params.website"
        clearable
        placeholder="请输入网址"
      />
    </div>
    <div class="base-item">
      <p>通讯地址<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.fullAddress"
        clearable
        placeholder="请输入通讯地址"
      />
    </div>
        <div class="base-item">
      <p>邮政编码<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.zipcode"
        clearable
        placeholder="请输入邮政编码"
      />
    </div>

    <div class="base-item">
    <p>联系人姓名<sup>*</sup></p >
    <van-field
            class="input-item"
            v-model="params.representName"
            clearable
            placeholder="请输入联系人姓名"
    />
</div>

  <div class="base-item">
      <p>联系人手机(用于接收消息通知)<sup>*</sup></p >
      <van-field
              class="input-item"
              v-model="params.mobile"
              clearable
              placeholder="请输入联系人手机"
      />
  </div>
  <div class="base-item">
        <p>联系人职务<sup></sup></p>
        <van-field
          class="input-item"
          v-model="params.representPosition"
          clearable
          placeholder="请输入联系人职务"
        />
      </div>
  <div class="base-item">
      <p>联系邮箱<sup>*</sup></p >
      <van-field
              class="input-item"
              v-model="params.email"
              clearable
              placeholder="请输入联系邮箱"
      />
  </div>
      <div class="base-item">
        <p>已加入的社会组织<sup></sup></p>
        <van-field
          class="input-item"
          v-model="params.experience"
          clearable
          placeholder="请输入已加入的社会组织"
        />
      </div>
    <div class="base-item">
                <p>业务范围<sup>*</sup></p>
                <van-checkbox-group v-model="result" direction="horizontal" @change="groupclick">
                <van-checkbox :name="item.value" v-for="(item, index) in BUSINESSSCOPELIST" :key="index" :value="item.value">{{item.name}}</van-checkbox>
                </van-checkbox-group>
             </div>

            <div class="base-item">
                <p>产品类型<sup></sup></p>
                <van-checkbox-group v-model="resultProductType" direction="horizontal" @change="PRODUCTTYPELISTCLICK()">
                <van-checkbox :name="item.value" v-for="(item, index) in PRODUCTTYPELIST" :value="item.value" :key="index">{{item.name}}</van-checkbox>
                </van-checkbox-group>
             </div>

            <div class="base-item">
                <p>主要产品<sup></sup></p>
                <van-field
                        class="input-item"
                        type="textarea"
                        v-model="params.masterProduct"
                        clearable
                        placeholder="请输入主要产品"
                />
            </div>
            <div class="base-item">
                <p>保护地生产面积（亩）</p>
                <van-field
                        class="input-item"
                        v-model="params.pgndArea"
                        clearable
                        placeholder="请输入保护地生产面积（亩）"
                />
            </div>
            <div class="base-item">
                <p>露地生产面积（亩）</p>
                <van-field
                        class="input-item"
                        v-model="params.openArea"
                        clearable
                        placeholder="请输入露地生产面积（亩）"
                />
            </div>

        <div class="base-item">
      <p>单位简介<sup>*</sup></p>
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.introduction"
        clearable
        placeholder="请输入单位简介"
      />
    </div>
    <!-- <div class="base-item">
      <p>负责人<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.pic"
        clearable
        placeholder="请输入负责人姓名"
      />
    </div>
   -->
<!--
    <div class="base-item">
      <p>单位性质<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.unitProperties"
        clearable
        placeholder="请输入单位性质"
      />
    </div>
    <div class="base-item">
      <p>注册地址<sup>*</sup></p>
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.fullAddress"
        clearable
        placeholder="请输入注册地址"
      />
    </div> -->

    <h3>
      <van-icon name="column" />法人信息
    </h3>
      <div class="base-item">
      <p>法人姓名<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.corporation"
        clearable
        placeholder="请输入法人姓名"
      />
    </div>
    <div class="base-item">
      <p>法人职务<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.corporationPosition"
        clearable
        placeholder="请输入法人职务"
      />
    </div>
    <div class="base-item">
      <p>法人手机号<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.corporationMobile"
        clearable
        placeholder="请输入法人手机号"
      />
    </div>
    <div class="base-item">
      <p>法人微信/QQ<sup></sup></p>
      <van-field
        class="input-item"
        v-model="params.corporationOicq"
        clearable
        placeholder="请输入法人微信/QQ"
      />
    </div>
    <div class="base-item">
      <p>法人邮箱<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.corporationEmail"
        clearable
        placeholder="请输入法人邮箱"
      />
    </div>
    <!-- <div class="base-item">
      <p>手机号<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.mobile"
        clearable
        placeholder="请输入手机号"
      />
    </div>
    <div class="base-item">
      <p>电子邮箱 <sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.email"
        clearable
        placeholder="请输入电子邮箱"
      />
    </div>
    <div class="base-item">
      <p>通讯地址  <sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.address"
        clearable
        placeholder="请输入通讯地址 "
      />
    </div>
    <div class="base-item">
      <p>邮政编码  <sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.zipcode"
        clearable
        placeholder="请输入邮政编码"
      />
    </div>
    <div class="base-item">
      <p>办公电话<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.telephone"
        clearable
        placeholder="请输入办公电话 "
      />
    </div>
    <div class="base-item">
      <p>传真<sup>*</sup></p>
      <van-field
        class="input-item"
        v-model="params.fax"
        clearable
        placeholder="请输入传真"
      />
    </div> -->
    <van-button class="nextBtn" type="primary" size="large" @click="next">下一步</van-button>

    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
            <van-datetime-picker
                    v-if="selectKey === 'foundDate'"
                    :value="params.foundDate"
                    type="date"
                    @cancel="onCancel"
                    @confirm="onConfirmDate"
                    :min-date="minDate"
            />
          <van-picker
                  v-else
            show-toolbar
            ref="picker"
            :value-key="key"
            :columns="columns"
            @change="onChange"
            @cancel="onCancel"
            @confirm="onConfirm"
          />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Uploader,
  Field,
  Cell,
  CellGroup,
  Button,
  Popup,
  Picker,
  Toast,
  NavBar,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
} from "vant";
import { mapState, mapGetters, mapActions ,mapMutations} from "vuex";
import { uploadFile, delFile } from "@/api/upload";
import { registerGroupEdit } from "@/api/login";
import {getUser,findFileById,getDictionaryByCode} from "@/api/dictionary";
import axios from "axios";

export default {
  data() {
    return {
      resultProductType:[],
      PRODUCTTYPELIST:[],
      BUSINESSSCOPELIST: [],
      multipleSelection: [],
      multipleSelectionProducType:[],
      result:[],
      minDate:null,
      fileList: [],
      fileList2: [],
      selectModel: false,
       title:'注册',
       selectList:{
         UNIT_PROPERTIES:[]
       },
      params: {
        name: "",
        code:"",
        corporation: "",
        registrationFullAddress: "",
        historyMemberNo: "",
        registeredCapital: "",
        researcherCount: "",
        representPosition: "",
        corporationPosition: "",
        representName: "",
        website: "",
        recommendUnitId: null,
        foundDate:new Date(),
        memberType: null,
        // licenceFileId: null,
        // portraitId: null,
        introduction: "",
        mobile:'',
        corporationEmail:'',
        corporationOicq:'',
        email:'',
        corporationMobile:'',
        fax:'',
        unitProperties:'',
        telephone:'',
        zipcode:'',
        address:'',
        fullAddress:'',
      },
      key: "", //选择弹窗显示对应的参数名
      selectKey: "", //所选择的字段
      titleGroup: "", //职称第一列的数据
      jgName: "",
      addName: "",
      columns: [],
      request: {
        memberType:"请选择单位类型",//
        recommendUnitId:'请选择推荐单位',
        name: "请输入单位会员名称",
        registrationFullAddress: "请输入住所",
        registeredCapital: "请输入注册资本金",
        researcherCount: "请输入职工人数",
        fullAddress: "请输入通讯地址",
        zipcode: "请输入邮政编码",
        introduction: "请输入单位简介",
        //pic:'请输入负责人名称',
        code:'请输入统一社会信用代码',
        foundDate: "请选择成立时间",
        //introduction: "请输入单位简介",
        //fullAddress:'请输入注册地址',
        //unitProperties:'请输入单位性质',
        mobile:'请输入联系人手机号',
        email:'请输入联系人邮箱',
        representName:'请输入联系人姓名',
        //representPosition:'请输入联系人职务',
        // zipcode:'请输入联系人邮政编码',
        //telephone:'请输入联系人办公电话',
        corporation: "请输入法人名称",
        corporationPosition: "请输入法人职务",
        corporationMobile: "请输入法人手机号",
        //corporationOicq: "请输入法人微信/QQ",
        corporationEmail: "请输入法人邮箱",
      }
    };
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [NavBar.name]:NavBar,
    [Checkbox.name]:Checkbox,
    [DatetimePicker.name]: DatetimePicker,
    [CheckboxGroup.name]:CheckboxGroup
  },
  watch: {
    "params.birthday"(date) {
      console.log(date);
    }
  },
  props: {
    member: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["branchsList","userInfo"]),
    ...mapGetters(["GROUP_TYPE"]),
    licenceFileId() {
      return this.$route.query && this.$route.query.licenceFileId;
    },
    portraitId() {
      return this.$route.query && this.$route.query.portraitId;
    },
    licenceFileName() {
      return this.$route.query && this.$route.query.licenceFileName;
    },
    portraitName() {
      return this.$route.query && this.$route.query.portraitName;
    },
    //minDate() {
      //return new Date("1960");
    //},
    foundDate() {
      let time = this.params.foundDate;
      return this.$global.format(time, "yyyy-MM-dd");
    }
  },
  methods: {
    ...mapActions(["getBranchsList","getDictionaryList"]),
    ...mapMutations(["setMemberInfo"]),
    goUpload(){
      this.setMemberInfo(this.params);
      this.$router.push({ name: 'groupUploadAttachments',query:{licenceFileName:this.licenceFileName,portraitName:this.portraitName,licenceFileId:this.licenceFileId,portraitId:this.portraitId}});
    },
    groupclick (event) {
              this.multipleSelection = [];
            // for (let i = 0; i < this.result.length; i++) {
            //     if (this.result.indexOf(this.result[i]) === -1) {
            //         this.multipleSelection.push(this.result[i])
            //     }
            // }

          },
          PRODUCTTYPELISTCLICK(){

             this.multipleSelectionProducType = [];
            for (let i = 0; i < this.resultProductType.length; i++) {
                if (this.resultProductType.indexOf(this.resultProductType[i]) === -1) {
                    this.multipleSelectionProducType.push(this.resultProductType[i])
                }
            }
            //console.log(this.multipleSelectionProducType)
          },
          toggle (index) {
            // let val = event.mp.currentTarget.dataset.name
            // let index = this.values.indexOf(val)
            // if (index <= -1) {
            //   this.values.push(val)
            // } else {
            //   this.values.splice(index, 1)
            // }
          },
        toggle1(index) {
            // let val = event.mp.currentTarget.dataset.name
            // let index = this.values.indexOf(val)
            // if (index <= -1) {
            //   this.values.push(val)
            // } else {
            //   this.values.splice(index, 1)
            // }
          },
    onClickLeft() {
        this.$router.push({name:"registerBox"})
    },
    onConfirmDate(time) {

      this.params.foundDate = time;
      this.selectModel = false;
    },
    getName(list, type, returnName) {
      let id = this.params[type];

      if (!id && id !== 0) {
        return returnName;
      } else {
        let obj = null;

        if (type === "recommendUnitId" || type === "concernUnitId") {
          obj = this[list].find(item => item.id === id);
          //this.params.recommendUnitId = obj.code;

      
        } else if (type === "title") {
          let group = this[list].find(item => item.value === this.titleGroup);
          let obj = group.children.find(item => item.value === id);

          return obj.label;
        } else {
          obj = this[list].find(item => item.value === id);
        }
        return obj.name;
      }
    },
    setSelectModel(type, key, selectKey, ismore) {
    let obj = this.$refs.picker;
      this.selectModel = true;
      this.key = key;
      this.selectKey = selectKey;

        if (obj) {
            this.$refs.picker.setIndexes([0, 0]);
           }

      //是否多级
      if (ismore) {
        this.columns = [
          {
            values: this[type],
            className: "column1"
          },
          {
            values: this[type][0].children,
            className: "column2"
          }
        ];
      } else {
        this.columns = this[type];
      }
    },
    onChange(picker, values, index) {
      if (this.selectKey === "title") {
        picker.setColumnValues(1, values[0].children);
      } else if (this.selectKey === "jg" || this.selectKey === "add") {
        let city = this.cityList.filter(item => {
          return item.parentId === values[0].id;
        });
        if (index === 0) {
          picker.setColumnValues(1, city);
        }
      }
    },
    onConfirm(item) {
      this.selectModel = false;
      if (
        this.selectKey === "recommendUnitId" ||
        this.selectKey === "concernUnitId"
      ) {
        this.params[this.selectKey] = item.id;
      } else {
        this.params[this.selectKey] = item.value;
      }
    },
    onCancel() {
      this.selectModel = false;
    },
      dateFormat(timeStamp) {
          let year = new Date(timeStamp).getFullYear();
          let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
          let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
          return year + "-" + month + "-" + date;
      },
    next() {
      let params = {
        ...this.member,
        ...this.params
      };
      params.licenceFileId = this.licenceFileId;
      params.portraitId= this.portraitId;
        if(!params.licenceFileId){
           Toast("加盖公章的营业执照复印件不能为空");
           return;
        }
      if(!params.code ||params.code.length<18){
        Toast("统一社会信用代码必须是18位");
         return;
      }
        if(params.foundDate){
             //params.foundDate = params.foundDate.substr(0, 10);
            params.foundDate = this.dateFormat(params.foundDate);
        }
      for (let item in this.request) {
        if (!this.params[item] || !("" + this.params[item]).length) {
          Toast(this.request[item]);
          return;
        }
      }

       if(this.result.length <= 0){
                  Toast.fail("业务范围不能为空!");
                  return
              }
              params.businessScope = this.result.join(",");
              if(this.multipleSelectionProducType.length > 0){

              }
              if(this.resultProductType && this.resultProductType.length > 0){
                  params.productType = this.resultProductType.join(",")
              }else{
                  params.productType = null;
              }


           if(params.businessScope){
               let temp = new Set(this.result.join(","));
               if(temp.has("1")){
                 if(!params.productType || !params.masterProduct){
                   Toast.fail("业务范围为花卉生产、花卉进口、花卉出口和花卉销售代理，产品类型必须填写。");
                   return;
                 }
               }
               if(temp.has("3")){
                if(!params.productType || !params.masterProduct){

                  Toast.fail("业务范围为花卉生产、花卉进口、花卉出口和花卉销售代理，产品类型必须填写。");
                   return;
                 }
               }
               if(temp.has("4")){
                if(!params.productType || !params.masterProduct){

                   Toast.fail("业务范围为花卉生产、花卉进口、花卉出口和花卉销售代理，产品类型必须填写。");
                   return;
                 }
               }
               if(temp.has("5")){
                if(!params.productType || !params.masterProduct){
                   Toast.fail("业务范围为花卉生产、花卉进口、花卉出口和花卉销售代理，产品类型必须填写。");
                   return;
                 }
               }
              }


      Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中..."
      });
      let obj = this['branchsList'].find(item => item.id === this.params.recommendUnitId);
      let obj2 = this['branchsList'].find(item => item.id === this.params.concernUnitId);
      params.recommendUnitId= obj.code;
      params.concernUnitId= obj2.code;

      registerGroupEdit(params)
        .then(res => {
          if (res.success) {
            this.$emit("sendActive", 2);
          } else {
            Toast(res.message || "操作失败1");
          }
        })
        .catch(res => {
          Toast.error("操作失败!");
        })
        .finally(() => {
          Toast.clear();
        });
    },
    getIdentityType(value) {
      for (let i = 0; i < this.selectList.UNIT_PROPERTIES.length; i++) {
        if (this.selectList.UNIT_PROPERTIES[i]["value"] === value) {
          return this.selectList.UNIT_PROPERTIES[i]["name"];
        }
      }
      return "";
    },
  },
  mounted() {
    // this.getIdentityType();
    this.getBranchsList();
    this.getDictionaryList();
          getDictionaryByCode("BUSINESS_SCOPE")
          .then(res=>{
              if(res.success){
                  this.BUSINESSSCOPELIST = res.result;
              }

          })
        getDictionaryByCode("PRODUCT_TYPE")
          .then(res=>{
              if(res.success){
                  this.PRODUCTTYPELIST = res.result;
              }

          })
    this.params.foundDate = new Date();
    if(this.userInfo){
      this.params = this.userInfo;
        this.params.foundDate = new Date();
    }
    this.minDate =new Date("1990-01-01");
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>

h3 {
  display: flex;
  margin-top: 25px;
  font-size: 16px;
  align-items: center;
  i {
    margin-right: 6px;
  }
}
.base-item /deep/.van-cell--required::before{ left:0}
.base-box /deep/.van-nav-bar{ position: absolute; top: 0; left: 0; width: 100%; z-index: 99;}
h4 {
  font-size: 14px;
  line-height: 2;
  span {
    display: inline-block;
    margin-left: 10px;
    color: #d64a4a;
  }
}
.base-item {
  margin: 15px 0;
}
.base-item p{ font-size:15px; color: #333; margin-top: 30px;}
.base-item p sup{ color: red; margin-top: 5px; display:block; float: left;}
.input-item {
  padding: 15px 0 18px 10px;
  border-bottom: 1px solid #efefef;
}
.warm {
  margin-top: 3px;
  color: #d64a4a;
  font-size: 12px;
}
.nextBtn {
  margin-top: 35px;
  height: 45px !important; 
  line-height: 45px;
}
.base-box > .van-cell {border-bottom: #efefef solid 1px;}
.base-box h3{ color: #228ccd;}
.base-box>p{font-size:13px; color:#999; line-height: 20px; margin-bottom:30px;}
</style>
